
// -----------------------------
// SET FIELDS.
// -----------------------------

import { getSetting } from '@woocommerce/settings';

export const ficooData = getSetting('ficoo-smart-connector-core_data', {});

const debugEnabled = ficooData.options?.debug_enabled === '1';

// Utilizzare un template per i messaggi
const createLogMessage = (level, msg) => `[${level}] ${msg}`;

// export const logger = debugEnabled ? {
//     info: (msg) => console.log(createLogMessage('INFO', msg)),
//     error: (msg) => console.error(createLogMessage('ERROR', msg)),
//     warn: (msg) => console.warn(createLogMessage('WARN', msg)),
//     p: (msg) => console.log(`     -> ${msg}`),
// } : {
//     info: () => null,
//     error: () => null,
//     warn: () => null,
//     p: () => null
// };

export const logger = debugEnabled ? {
    info: (msg) => console.log(createLogMessage('INFO', msg)),
    error: (msg) => console.error(createLogMessage('ERROR', msg)),
    warn: (msg) => console.warn(createLogMessage('WARN', msg)),
    p: (msg, ...args) => console.log(`     -> ${msg}`, ...args), // Accept multiple arguments.
} : {
    info: () => null,
    error: () => null,
    warn: () => null,
    p: () => null
};